import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type CreateCastRelationshipBody = NonNullable<
  paths['/api/v1/cast_relationships']['post']['requestBody']
>['content']['application/json'];

export type CreateCastRelationshipResponse =
  paths['/api/v1/cast_relationships']['post']['responses']['201']['content']['application/json']['castRelationship'];

export type CastRelationshipResponse =
  paths['/api/v1/cast_relationships/{id}']['get']['responses']['200']['content']['application/json']['castRelationship'];

export type CastRelationshipsResponse =
  paths['/api/v1/cast_relationships']['get']['responses']['200']['content']['application/json']['castRelationships'];

export type UpdateCastRelationshipBody = NonNullable<
  paths['/api/v1/cast_relationships/{id}']['put']['requestBody']
>['content']['application/json'];

export type UpdateCastRelationshipResponse =
  paths['/api/v1/cast_relationships/{id}']['put']['responses']['200']['content']['application/json']['castRelationship'];

export async function createCastRelationship(
  body: CreateCastRelationshipBody
): Promise<CreateCastRelationshipResponse> {
  const { data, error } = await client.POST('/api/v1/cast_relationships', {
    headers: authHeaders(),
    body
  });

  if (error) throw error;
  if (!data) throw new Error('Empty response when creating cast relationship');
  return data.castRelationship;
}

export async function getCastRelationshipById({
  castRelationshipId
}: {
  castRelationshipId: string;
}): Promise<CastRelationshipResponse> {
  const { data, error } = await client.GET('/api/v1/cast_relationships/{id}', {
    headers: authHeaders(),
    params: { path: { id: castRelationshipId } }
  });

  if (error) throw error;
  if (!data) throw new Error('Empty response when getting cast relationship by id');
  return data.castRelationship;
}

export async function getCastRelationships({
  page,
  perPage
}: {
  page: number;
  perPage: number;
}): Promise<CastRelationshipsResponse> {
  const { data, error } = await client.GET('/api/v1/cast_relationships', {
    headers: authHeaders(),
    params: { query: { page, per_page: perPage } }
  });

  if (error) throw error;
  if (!data) throw new Error('Empty response when getting cast relationships');
  return data.castRelationships;
}

export async function updateCastRelationship({
  castRelationshipId,
  body
}: {
  castRelationshipId: string;
  body: UpdateCastRelationshipBody;
}): Promise<UpdateCastRelationshipResponse> {
  const { data, error } = await client.PUT('/api/v1/cast_relationships/{id}', {
    headers: authHeaders(),
    params: { path: { id: castRelationshipId } },
    body
  });

  if (error) throw error;
  if (!data) throw new Error('Empty response when updating cast relationship');
  return data.castRelationship;
}